import { render, staticRenderFns } from "./TopicCloudItem.vue?vue&type=template&id=641cafaa&scoped=true&"
import script from "./TopicCloudItem.vue?vue&type=script&lang=js&"
export * from "./TopicCloudItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicCloudItem.vue?vue&type=style&index=0&id=641cafaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cafaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
